import type OrderModel from '~/models/OrderModel'
import type { ProductModel } from '~/models/ProductModel'

export const isPending = (arg0: ProductModel) => arg0.status === 'pending'

export const isApproved = (arg0: ProductModel) => arg0.status === 'approved'

export const isApprovedOrPartialRefund = (arg0: ProductModel) => arg0.status === 'approved' || arg0.status === 'partialRefund'

export const sumFunc = (price1: string | number, price2: string | number) => Number(price1) + Number(price2)

export function getTotal(product: ProductModel) {
  const { count, price } = product
  return product?.loyaltyProgramCount
    ? (count - product?.loyaltyProgramCount) * price
    : count * price
}

export const getTotalSimple = (arg0: ProductModel) => arg0.count * arg0.price

export function getCutleryTotal(order: OrderModel) {
  return order.cutleryCount
    ? order.cutleryCount * order.cutleryPrice
    : 0
}

export function getPaperBagTotal(order: OrderModel) {
  return order.paperBagCount
    ? order.paperBagCount * order.paperBagPrice
    : 0
}

export function getOrdersTotal(orders: ProductModel[]) {
  return orders
    .map(getTotal)
    .reduce(
      sumFunc,
      0,
    )
}

export function getOrdersTotalSubsidy(orders: ProductModel[], subsidyPrice = 0) {
  const result = orders
    .map(getTotal)
    .reduce(
      sumFunc,
      0,
    )
  const sum = subsidyPrice >= result
    ? 0
    : result - subsidyPrice

  return sum
}

export function getOrdersTotalWithoutLoyaltyProgramCount(orders: ProductModel[]) {
  return orders
    .map(getTotalSimple)
    .reduce(
      sumFunc,
      0,
    )
}

export const roundResult = (sum = 0) => Math.ceil(sum * 100) / 100

export function getTotalWithSalesPercentage(order: OrderModel, sum: number) {
  if (order.salesPercentage && order.salesPercentage !== 0)
    return Math.round(sum * (1 - order.salesPercentage) * 100) / 100

  return roundResult(sum)
}
